<script>
import moment from 'moment';
export default {
  name: 'SelectionBlackbookComment',
  props: {
    mainText: {
      type: String,
      required: true,
      default: '',
    },
    timeUpdated: {
      type: Date,
      required: true,
      default: '',
    },
  },
  computed: {
    formatTime() {
      moment.locale();
      return moment(this.timeUpdated).format('Do MMM YYYY');
    },
  },
};
</script>

<template>
  <div class="select-bb-comment">
    <div class="select-bb-comment__container">
      <div class="select-bb-comment__last-updated">Last Updated: {{ formatTime }}</div>
      <div class="select-bb-comment__main-text">{{ mainText }}</div>
    </div>
  </div>
</template>
